import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
      path: '',
      redirect: '/index',
    },
    {
      path: '/index/:id',
      component: () => import('@/views/home/Home'),
    },
  ]
const router = createRouter({
  // 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes, // `routes: routes` 的缩写
})

export default router
